import "./helpButton.css";
import React, { useState } from "react";
import { withNamespaces } from "react-i18next";

import { FloatButton, Modal } from "antd";
import { useLocation } from "react-router-dom";
import HowItWork from "../../pages/HowItWork/HowItWork";
import { CommentOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import SupportRequestLayout from "../SupportRequestBox/SupportRequestLayout";

const HelpButton = ({ t }) => {
  const { pathname } = useLocation();
  const page = pathname.split("/")[1];

  const [howItWorkModalOpen, setHowItWorkModalOpen] = useState(false);
  const handleOpenHowItWork = () => {
    setHowItWorkModalOpen(true);
  };
  const handleCloseHowItWork = () => {
    setHowItWorkModalOpen(false);
  };

  const [supportRequestOpen, setSupportRequestOpen] = useState(false);
  const handleOpenSupportRequest = () => {
    setSupportRequestOpen(true);
  };
  const handleCloseSupportRequest = () => {
    setSupportRequestOpen(false);
  };

  return (
    <>
      <FloatButton.Group
        trigger="click"
        type="primary"
        style={{
          right: 10,
          bottom: 10,
        }}
        icon={<QuestionCircleOutlined style={{ fontSize: "20px" }} />}
      >
        <FloatButton
          onClick={handleOpenHowItWork}
          tooltip={<div>{t("how_ıt_work_title")}</div>}
        />
        <FloatButton
          onClick={handleOpenSupportRequest}
          icon={<CommentOutlined />}
          tooltip={<div>{t("support_request_title")}</div>}
        />
      </FloatButton.Group>

      <Modal
        title={""}
        open={howItWorkModalOpen}
        onCancel={handleCloseHowItWork}
        footer={null}
        width={"80%"}
      >
        {/* //Modal içeriği burada olacak */}

        {/* //Her sayfaya özel içeriği buraya yerleştirin */}
        <HowItWork />
      </Modal>

      <Modal
        title={
          <h3>
            <i className="fa-solid fa-circle-question" />{" "}
            {t("support_request_title")}
          </h3>
        }
        open={supportRequestOpen}
        onCancel={handleCloseSupportRequest}
        footer={null}
        width={"80%"}
        // bodyStyle={{ height: "70vh", overflow: "hidden" }}
        style={{ height: "95vh", overflow: "hidden", top: "2rem" }}
        className="support-modal-container"
      >
        {/* //Modal içeriği burada olacak */}
        {/* //Destek Talep içeriği burada olacak */}
        {/* <SupportRequestModal handleCloseModal={handleCloseSupportRequest} /> */}
        <SupportRequestLayout
          handleCloseModal={handleCloseSupportRequest}
          supportRequestOpen={supportRequestOpen}
        />
      </Modal>
    </>
  );
};

export default withNamespaces()(HelpButton);